window.$ = require('jquery');
window.jQuery = window.$;
window._ = require('lodash');
window.moment = require('moment');

require('moment/locale/es');
require('../../lang/val/moment');

require('bootstrap');
require('admin-lte');
require('select2');

require('parsleyjs');
require('parsleyjs/dist/i18n/es');
require('parsleyjs/dist/i18n/en');
require('../../lang/val/parsleyjs');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.routes = require('./util/routes');
window.translations = require('./util/translations');
window.translatable_fields = require('./util/translatable_fields');
window.messages = require('./util/messages');
window.datatables = require('./util/datatables');
window._tinymce = require('./util/tinymce');
window.blockui = require('./util/blockui');
window.menu = require('./util/menu');
window.ajax = require('./util/ajax');
window.coordinates = require('./util/coordinates');

window.app = {};
window.app.profile = require('./app/profile');

window.app.admin = {
    users: require('./app/admin/users'),
    logs: require('./app/admin/logs'),
};

window.app.rinfresco = {
    stock: require('./app/rinfresco/stock'),
    providers: require('./app/rinfresco/providers'),
    categories: require('./app/rinfresco/categories'),
    clients: require('./app/rinfresco/clients'),
    comparatives: require('./app/rinfresco/comparatives'),
    imports: require('./app/rinfresco/imports'),
};